import { TierIIReportKind } from "encamp-prisma/generated/client/client";
import { findAlternateId } from "encamp-shared/src/facilityAlternateId/findAlternateId";
import { TabProxy } from "encampy";
import {
  AlternateId,
  CredentialSecurityQuestion,
} from "generated-graphql/graphql";

export async function automateTxLogin({
  tab,
  username,
  password,
  securityQuestions,
  facilityAlternateIds,
  reportingYear,
  reportKind,
}: {
  tab: TabProxy;
  username: string;
  password: string;
  securityQuestions: CredentialSecurityQuestion[];
  facilityAlternateIds?: AlternateId[];
  reportingYear?: number;
  reportKind?: TierIIReportKind;
}): Promise<void> {
  // Wait for the login page to load
  await tab.waitForElement("input#username", { timeout: 10000 });

  // Type in the username
  await tab.type("input#username", username);

  // Type in the password
  await tab.type("input#password", password);

  // Click Login
  await tab.click("p.loginbutton > input");

  // Wait for navigation to complete after login
  await tab.waitForNavigation({ timeout: 10000 });

  // Handle security question by reading the question and typing the matching answer
  await tab.conditionalTypeText(
    "label[for='secur_quest_ans']",
    securityQuestions.map((sq) => ({
      matchText: sq.question,
      typeSelector: "input#secur_quest_ans",
      typeText: sq.answer,
    }))
  );

  // Submit the security question answer
  await tab.click("input[type='image'][name='go']");
  await tab.waitForNavigation({ timeout: 10000 });

  // Wait for the login confirmation page and click Yes
  const yesButtonSelector = "input[type='image'][alt='Yes']";
  await tab.waitForElement(yesButtonSelector, { timeout: 10000 });
  await tab.click(yesButtonSelector);
  await tab.waitForNavigation({ timeout: 10000 });

  if (facilityAlternateIds) {
    const cn = findAlternateId(facilityAlternateIds, ["STEERS_CN"]);
    const rn = findAlternateId(facilityAlternateIds, ["STEERS_RN"]);

    if (cn && rn) {
      // If we have a CN and RN, find the report
      await tab.clickElementByText("Tier II Reporting", "a");
      await tab.waitForNavigation({ timeout: 10000 });

      // Filter by the CN
      await tab.type("input[id='accountsDT:cnCol:filter']", cn.value, {
        submit: true,
      });
      await tab.wait({
        duration: 1000,
      });

      // Select the CN
      await tab.click(
        `table > tbody#accountsDT_data > tr > td:first-child span.ui-radiobutton-icon`
      );

      // Click Select
      await tab.click("button#selectBtn");
      await tab.waitForNavigation({ timeout: 10000 });

      // Navigate to Facility Report Search
      await tab.navigate(
        "/tceq-tier2-external/secure/trt0400_facilitySearch.jsf?flow=CLEAR&faces-redirect=true"
      );

      // Search by the RN
      await tab.type("input[id='fsfFacilitySearch:rn']", rn.value);

      // Click Search
      await tab.click("button[id='fsfFacilitySearch:facilitySearchBtn']");
      await tab.waitForNavigation({ timeout: 10000 });

      if (reportKind) {
        // Select the report kind
        await tab.select(
          "select[id='facilitiesList:j_idt108_input']",
          reportKind
        );
      }

      if (reportingYear) {
        // Select the reporting year
        await tab.select(
          "select[id='facilitiesList:j_idt113_input']",
          reportingYear.toString()
        );
      }
    }
  }
}
